import {
  getGoldSpecialOffers,
  getIntlSpecialOffers,
  getSilverSpecialOffers,
} from "./getSpecialOffers";

// Get hotels special offer & add into hotel object
const getSpecialOffersForHotels = (hotels, specialOffers) => {
  // -> SPECIAL OFFERS PREP
  const goldOffers = getGoldSpecialOffers(specialOffers);
  const silverOffers = getSilverSpecialOffers(specialOffers);
  const internationalOffers = getIntlSpecialOffers(specialOffers);
  // Loop through hotels and add the title of special offers, go from lowest top as it will overwrite any it finds so in this order - newest gold is saved
  hotels.forEach((hotel) => {
    let offersArray = [goldOffers, silverOffers, internationalOffers];
    let offerArr = [];

    offersArray.forEach((array) => {
      array.filter((offer) => {
        if (offer.hotelId !== null) {
          if (offer.hotelId._id === hotel._id) {
            return offerArr.push(offer);
          } else return null;
        }
      });
    });
    if (offerArr.length) {
      hotel.specialOffer = offerArr;
    } else return;
  });
  return { hotels, goldOffers, silverOffers, internationalOffers };
};

export default getSpecialOffersForHotels;
